import React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import twMerge from "@replo/design-system/utils/twMerge";
import { ArrowRight } from "lucide-react";

interface OnboardingFooterProps {
  onNext: (e: React.MouseEvent) => void;
  onBack?: () => void;
  isNextDisabled?: boolean;
  isNextLoading?: boolean;
  nextButtonText?: string;
  className?: string;
  showBackButton?: boolean;
  onSecondaryCTAClick?: () => void;
  showSecondaryCTA?: boolean;
  isSecondaryCTADisabled?: boolean;
  isSecondaryCTALoading?: boolean;
  backButtonVariant?: "secondary" | "tertiary";
}

const OnboardingFooter: React.FC<OnboardingFooterProps> = ({
  onNext,
  onBack,
  isNextDisabled = false,
  isNextLoading = false,
  nextButtonText = "Continue",
  className,
  showBackButton = true,
  onSecondaryCTAClick,
  showSecondaryCTA = false,
  isSecondaryCTADisabled = false,
  isSecondaryCTALoading = false,
  backButtonVariant = "secondary",
}) => {
  return (
    <div className="border-border flex w-full justify-center bg-white px-4 py-4 md:border-t md:px-0 md:py-6">
      <div
        className={twMerge(
          "flex w-full items-center gap-3",
          showSecondaryCTA ? "justify-between" : "justify-end",
          className,
        )}
      >
        {showBackButton && (
          <Button
            variant={backButtonVariant}
            size="lg"
            onClick={onBack}
            className="hidden md:flex"
          >
            Back
          </Button>
        )}
        <div className="flex flex-col w-full items-stretch gap-3 md:flex-row md:w-auto md:items-center md:gap-4">
          {showSecondaryCTA && (
            <Button
              variant="secondary"
              size="lg"
              onClick={onSecondaryCTAClick}
              disabled={isSecondaryCTADisabled}
              loading={isSecondaryCTALoading}
            >
              {isSecondaryCTALoading ? "Loading..." : "Start Building First"}
            </Button>
          )}
          <Button
            variant="primary"
            onClick={onNext}
            disabled={isNextDisabled}
            loading={isNextLoading}
            size="lg"
            endEnhancer={
              isNextLoading ? undefined : <ArrowRight className="h-4 w-4" />
            }
          >
            {isNextLoading ? "Loading..." : nextButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingFooter;
